class Entries {
  constructor() {
    this.selectors = {
      entry: '.js-km-awards-entry',
      hideIfEmpty: '.js-hide-if-empty',
      showIfEmpty: '.js-show-if-empty',
    };

    this.classnames = {
      active: 'is-active',
    };

    this.cancelEntryResponseHandler();
  }

  cancelEntryResponseHandler() {
    document.addEventListener('kmAwardsAjaxButtonResponse', (e) => {
      const { endpoint, response } = e.detail;

      if (endpoint !== 'user-cancel-entry') {
        return;
      }

      const { data } = response;

      if (data.cancelled) {
        const entry = document.getElementById(`entry-${data.entry_id}`);

        if (entry) {
          entry.remove();
        }

        const entries = document.querySelectorAll(this.selectors.entry);

        if (entries.length === 0) {
          const hideIfEmpty = document.querySelectorAll(this.selectors.hideIfEmpty);
          const showIfEmpty = document.querySelectorAll(this.selectors.showIfEmpty);

          if (hideIfEmpty.length > 0) {
            hideIfEmpty.forEach((el) => {
              el.remove();
            });
          }

          if (showIfEmpty.length > 0) {
            showIfEmpty.forEach((el) => {
              el.classList.add(this.classnames.active);
            });
          }
        }
      }
    });
  }
}

export default () => {
  new Entries();
};
